<template>
  <div class="collect">
    <div class="btn_box_private">
      <!-- <div class="btn_private" @click="batchCollect()">{{$t('MySpace.canelCollect')}}</div> -->
      <el-popconfirm
        @onConfirm="batchCollect()"
        :title="$t('MySpace.tip.uncollectSelectDatasat')"
        :cancel-button-text="$t('MySpace.tip.cancel')"
        :confirm-button-text="$t('MySpace.tip.confirm')"
      >
        <el-button class="btn_private" slot="reference">
          {{ $t("MySpace.canelCollect") }}</el-button
        >
      </el-popconfirm>
    </div>
    <div class="table_b">
      <el-table
        :data="collectData"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column fixed type="selection" width="35"></el-table-column>
        <el-table-column :label="$t('MySpace.thumbnail')" width="120">
          <template slot-scope="scope">
            <img
              style="width: 50px; height: 50px"
              :src="`${GLOBAL.imageUrl}${scope.row.thumbnail}`"
              alt
            />
          </template>
        </el-table-column>
        <el-table-column prop="productName" :label="$t('MySpace.dataSatName')">
        </el-table-column>

        <el-table-column prop="createTime" :label="$t('MySpace.createTime')">
        </el-table-column>
        <el-table-column fixed="right" :label="$t('MySpace.Operation')">
          <template slot-scope="scope">
            <!-- <div class="btn_box_private">
              <el-button
                class="btn_private"
                @click="handleClick(scope.row)"
                type="text"
                size="small"
                >{{$t('MySpace.canelCollect')}}</el-button
              >
            </div> -->

            <el-popconfirm
              @onConfirm="handleClick(scope.row)"
              :title="$t('MySpace.tip.uncollecttheDatasat')"
              :cancel-button-text="$t('MySpace.tip.cancel')"
              :confirm-button-text="$t('MySpace.tip.confirm')"
            >
              <el-button class="btn_private" slot="reference">
                {{ $t("MySpace.canelCollect") }}</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer_page" v-log="{ params: { clickName: '下载数据' } }">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/bus";
import { favoritesList, deleteFavorites } from "@/axios/private.js";
export default {
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      total: null,
      collectData: [],
      collectionData: [],
    };
  },
  methods: {
    // 校验是否登录
    verifyLogin() {
      return localStorage.getItem("token") && localStorage.getItem("loginName");
    },
    handleClick(tab, event) {
      var userVerifyLogin = this.verifyLogin();

      if (!userVerifyLogin) {
        // 提示用户登录
        bus.$emit("LoginDialogEmit");
        return;
      }
      // console.log(tab.id, event);
      this.deleteFavoritesFun(tab.id).then((res) => {
        this.favoritesListFun().then((res) => {
          this.collectData = res.data.data.records;
          this.total = res.data.data.total;
        });
      });
    },
    batchCollect() {
      var userVerifyLogin = this.verifyLogin();

      if (!userVerifyLogin) {
        // 提示用户登录
        bus.$emit("LoginDialogEmit");
        return;
      }

      if (this.collectionData.length == 0) {
        this.$message({
          message: this.$t("MySpace.tip.seleteDataEntry"),
          duration: 1000,
        });
        return;
      }
      var batchCollect = [];
      var batchIdsStr;
      this.collectionData.forEach((obj) => {
        console.log(obj);
        batchCollect.push(obj.id);
      });
      batchIdsStr = batchCollect.join(",");
      console.log(batchIdsStr);
      this.deleteFavoritesFun(batchIdsStr).then((res) => {
        this.favoritesListFun().then((res) => {
          this.collectData = res.data.data.records;
          this.total = res.data.data.total;
        });
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.favoritesListFun().then((res) => {
        this.collectData = res.data.data.records;
        this.total = res.data.data.total;
      });
    },
    async deleteFavoritesFun(ids) {
      return await deleteFavorites(ids);
    },
    async favoritesListFun() {
      var param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      return await favoritesList(param);
    },
    handleSelectionChange(obj) {
      this.collectionData = obj;
    },
  },
  mounted() {
    this.favoritesListFun().then((res) => {
      this.collectData = res.data.data.records;
      this.total = res.data.data.total;
    });
  },
};
</script>

<style lang="scss">
.collect {
  margin-bottom: 10px;
  th {
    background: #e9f7fe;
  }
  .table_b {
    margin-top: 20px;
  }
  .btn_box_private {
    display: flex;
    width: fit-content;
    margin: 10px 0;
  }
  .btn_private {
    padding: 4px 20px;
    margin-right: 4px;
    border: 1px solid #0a97d9;
    border-radius: 20px;
    color: #0a97d9;
    cursor: pointer;
    font-size: 14px;
    &:hover {
      background: #0a97d9;
      color: #fff;
    }
  }
  .footer_page {
    text-align: center;
    margin: 20px auto;
  }
}
</style>